class Usuario{
  constructor(idusuario,nombrecompleto,usuario, autorizado, token, roles,idUsuarioAplicacion){
    this.idusuario=idusuario;
    this.nombreCompleto=nombrecompleto;
    this.usuario=usuario;
    this.autorizado = autorizado
    this.token=token
    this.roles=roles
    this.idUsuarioAplicacion=idUsuarioAplicacion
  }
}

export default Usuario;